import React from 'react'
import CountUp from 'react-countup'
import TrackVisibility from 'react-on-screen'
import {counter} from './Counter.module.scss'

interface Props {
  start: number
  end: number
  className?: string
  suffix?: string
}

const Counter: React.FC<Props> = (props) => {
  const {start, end, suffix = '', className = ''} = props
  return (
    <TrackVisibility className={className} partialVisibility once>
      {({isVisible}) =>
        isVisible ? (
          <CountUp
            className={counter}
            start={start}
            end={end}
            duration={4}
            suffix={suffix}
            useEasing
          />
        ) : null
      }
    </TrackVisibility>
  )
}

export default Counter
